export default "__VITE_ASSET__CazOArJr__"